import React, { memo } from 'react';
import ms from 'ms';
import { routes } from 'constants/config';
import Chart from 'components/Chart';
import colors from 'constants/colors';
import InfoTooltip from 'components/shared/InfoTooltip';
import LoadableState from 'components/shared/loadable';
import DateRangeFormat from '../_shared/DateRangeFormat';
import FilteredRequest from '../_shared/FilteredRequest';

const getTooltip = filterParams =>
  filterParams.start_date || filterParams.end_date
    ? t('insights.assignments.weekly_completions.description_with_filter')
    : t('insights.assignments.weekly_completions.description');

const WeeklyAssignmentsChart = memo(({ i18n }) => (
  <FilteredRequest
    url={routes.INSIGHTS.COMPLETED_ASSIGNMENTS.WEEKLY_ASSIGNMENTS}
    include={{
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }}
  >
    {({ data, loading, params }) => (
      <LoadableState loading={loading}>
        <h3 className="DataCard-title">
          {i18n.assignments.weekly_completions.title}
          <InfoTooltip tooltip={getTooltip(params)} className="ml-4" />
          <span className="DataCard-subtitle">
            {params.start_date || params.end_date ? (
              <DateRangeFormat
                start={params.start_date}
                end={params.end_date}
              />
            ) : (
              i18n.timeframes.last_90_days
            )}
          </span>
        </h3>
        {!data && i18n.loading}
        {data && (
          <Chart
            config={{
              chart: {
                type: 'line',
                height: '50%',
              },
              xAxis: {
                type: 'datetime',
                tickInterval: ms('30 days'),
                dateTimeLabelFormats: {
                  month: '%b 1',
                },
              },
              yAxis: {
                // Show only the minimum and maximum values on the scale
                tickAmount: 2,
              },
              series: [
                // I would like to avoid manually parsing the dates to the JS
                // timestamps Highcharts expectes, but can't figure out how.
                {
                  name: i18n.assignments.weekly_completions.series.assignments,
                  data: data.assignments.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.BLUE,
                },
                {
                  name: i18n.assignments.weekly_completions.series.completions,
                  data: data.completions.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.GREEN,
                },
              ],
            }}
          />
        )}
      </LoadableState>
    )}
  </FilteredRequest>
));

export default WeeklyAssignmentsChart;
